<template>
  <div class="plv-iar-order">
    <div class="plv-iar-order-container">
      <!-- 有物流 -->
      <address-block
        v-if="ifNeedAddress"
        :data-source="address"
        :style="{ marginBottom: '8px' }"
        @click="navigateToAddressManagement"
      />
      <!-- 无物流 - 填手机号 -->
      <phone-input
        v-else
        v-model="mobile"
        ref="phoneInputRef"
        :style="{ marginBottom: '8px' }"
        @phone-input-focus="handlePhoneInputFocus"
        @phone-input-blur="handlePhoneInputBlur"
      />
      <product-card :data-source="product" v-for="product in products" :key="product.id" />

      <!-- 支付方式 -->
      <payment-methods
        class="plv-iar-order__payment-methods"
        v-model="paymentMethod"
        :disabled="disabledPaymentMethod"
        :exclude-payment-methods="excludePaymentMethods"
        @change="handlePaymentMethodChange"
        v-if="showPaymentMethod"
      />
    </div>
    <submit-bar
      class="plv-iar-order__submit-bar plv-iar-order__bottom"
      :price="totalPrice"
      :disabled="submitDisabled"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import AddressBlock from '../../components/order/AddressBlock';
import PhoneInput from '../../components/order/phone-input/PhoneInput';
import ProductCard from '../../components/order/ProductCard';
import SubmitBar from '../../components/order/SubmitBar';
import PaymentMethods from '../../components/order/PaymentMethods';
import order from './order';

export default {
  mixins: [order],

  components: {
    AddressBlock,
    PhoneInput,
    ProductCard,
    SubmitBar,
    PaymentMethods
  }
};
</script>

<style lang="scss">
.plv-iar-order {
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  line-height: 1.2;

  .plv-iar-order-container {
    box-sizing: border-box;
    overflow-y: scroll;
    flex: 1;
    padding: 8px 12px;
  }

  .plv-iar-order__submit-bar {
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .plv-iar-order__payment-methods {
    margin-top: 12px;
  }
}
</style>
